import { render, staticRenderFns } from "./DropdownNotifications.vue?vue&type=template&id=308f0c77&"
import script from "./DropdownNotifications.vue?vue&type=script&lang=js&"
export * from "./DropdownNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DropdownNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports